// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"394":"b5f1616c","463":"5890b1b6","665":"ceedf53f"}[chunkId] + ".chunk.js";
};